import qs from "qs";
export function parseConfigFromQueryAction(query) {
  var _parsedQueryString$ac;
  const parsedQueryString = qs.parse(query, {
    ignoreQueryPrefix: true
  });
  const parsedConfig = (_parsedQueryString$ac = parsedQueryString.action) === null || _parsedQueryString$ac === void 0 ? void 0 : _parsedQueryString$ac.follow_topic_package;
  if (!parsedConfig || parsedConfig.checkedIndex.length === 0) return;
  return parsedConfig;
}
export function queryFromConfig(config) {
  const query = {
    action: {
      follow_topic_package: config
    }
  };
  return qs.stringify(query, {
    arrayFormat: "comma"
  });
}